export default __webpack_public_path__ + "static/media/privacy-img.ec4f6e85.png";